/**
 * COMPETITON interfaces and types
 */
export interface ISeason {
  seasonId: number | string; // FIXME: BE QUERIES return BOTH!
  isSeasonComplete?: boolean;
  isSeasonStarted?: boolean;
}

export interface ICompetition extends ISeason {
  competitionId?: number | string; // FIXME: BE QUERIES return BOTH!
  competitionPhase?: string;
  competitionPhaseRound?: string;
}

export interface ICompetitionRound extends ICompetition {
  round: number;
  status: CompetitionRoundStatus;
  url?: string;
}

const CONTINENTAL_CUP_MAIN: CompetitionClassification = 'continental-cup-main';
const CONTINENTAL_CUP_MAIN_PLAY_OFF: CompetitionClassification = 'continental-cup-main-play-off';
const CONTINENTAL_CUP_MINOR: CompetitionClassification = 'continental-cup-minor';
const CONTINENTAL_CUP_MINOR_PLAY_OFF: CompetitionClassification = 'continental-cup-minor-play-off';
const CONTINENTAL_CUP_THIRD: CompetitionClassification = 'continental-cup-third';
const CONTINENTAL_CUP_THIRD_PLAY_OFF: CompetitionClassification = 'continental-cup-third-play-off';
const RELEGATION: CompetitionClassification = 'relegation';
const RELEGATION_PLAY_OUT: CompetitionClassification = 'relegation-play-out';
const PROMOTION: CompetitionClassification = 'promotion';
const PROMOTION_PLAY_OFF: CompetitionClassification = 'promotion-play-off';

export type CompetitionClassification =
  | 'continental-cup-main'
  | 'continental-cup-main-play-off'
  | 'continental-cup-minor'
  | 'continental-cup-minor-play-off'
  | 'continental-cup-third'
  | 'continental-cup-third-play-off'
  | 'relegation'
  | 'relegation-play-out'
  | 'promotion'
  | 'promotion-play-off';

const competitionClassificationList: CompetitionClassification[] = [
  CONTINENTAL_CUP_MAIN,
  CONTINENTAL_CUP_MAIN_PLAY_OFF,
  CONTINENTAL_CUP_MINOR,
  CONTINENTAL_CUP_MINOR_PLAY_OFF,
  CONTINENTAL_CUP_THIRD,
  CONTINENTAL_CUP_THIRD_PLAY_OFF,
  RELEGATION,
  RELEGATION_PLAY_OUT,
  PROMOTION,
  PROMOTION_PLAY_OFF,
];

const COMPETITION_ROUND_STATUS_PAST = 'past';
const COMPETITION_ROUND_STATUS_CURRENT = 'current';
const COMPETITION_ROUND_STATUS_FUTURE = 'future';

export type CompetitionRoundStatus = 'past' | 'current' | 'future';

const competitionStatusList: CompetitionRoundStatus[] = [
  COMPETITION_ROUND_STATUS_PAST,
  COMPETITION_ROUND_STATUS_CURRENT,
  COMPETITION_ROUND_STATUS_FUTURE,
];

export {
  CONTINENTAL_CUP_MAIN,
  CONTINENTAL_CUP_MAIN_PLAY_OFF,
  CONTINENTAL_CUP_MINOR,
  CONTINENTAL_CUP_MINOR_PLAY_OFF,
  CONTINENTAL_CUP_THIRD,
  CONTINENTAL_CUP_THIRD_PLAY_OFF,
  RELEGATION,
  RELEGATION_PLAY_OUT,
  PROMOTION,
  PROMOTION_PLAY_OFF,
  COMPETITION_ROUND_STATUS_PAST,
  COMPETITION_ROUND_STATUS_CURRENT,
  COMPETITION_ROUND_STATUS_FUTURE,
  competitionClassificationList,
  competitionStatusList,
};
